const init = () => {
  const openButton = document.querySelector('.js-couponOpenButton');
  const closeButton = document.querySelector('.js-couponCloseButton');
  const contentElm = document.querySelector('.js-couponContent');
  if(!openButton || !closeButton || !contentElm) return;

  openButton.addEventListener('click', () => {
    contentElm.classList.add('is-active');
  });

  closeButton.addEventListener('click', () => {
    contentElm.classList.remove('is-active');
  });

  const fixedCouponToggle = document.querySelector('.js-fixedCouponToggle');
  if(!fixedCouponToggle) return;

  const footerElm = document.querySelector('footer');

  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const footerTop = footerElm.getBoundingClientRect().top + scrollY;
    const windowHeight = window.innerHeight;
    if (scrollY + windowHeight >= footerTop) {
      fixedCouponToggle.classList.add('is-hidden');
    } else {
      fixedCouponToggle.classList.remove('is-hidden');
    }
  });
}

export {
  init
}